<template>
	<ui-dialog
		ref="dialog"
		title="Create new stream"
		closable
		@close="$emit('close')"
	>
		<ui-radio-group v-model="isExternal">
			<ui-radio
				:value="false"
				label="Use this cloud service"
			/>
			<ui-radio
				:value="true"
				label="Use third-party RTMP service (e.g. YouTube or Facebook)"
			/>
		</ui-radio-group>
		<ui-input
			v-model="streamTitle"
			label="Stream title"
		/>
		<ui-input
			v-if="isExternal"
			v-model="streamURI"
			label="RTMP URL"
			hint="Concatenate server URL and stream key separated by a slash (/), to form a complete URL"
		/>
		<ui-checkbox
			v-model="isDefaultStream"
			label="Use as default"
		/>
		<ui-dialog-footer>
			<ui-button
				:disabled="isFetching || streamTitle.length === 0"
				primary
				text="Create"
				tooltip="Create stream"
				@click="createStream"
			/>
		</ui-dialog-footer>
	</ui-dialog>
</template>

<script>
import alert from "lib/modules/Alert";
import http from "lib/modules/Http";
import UiButton from "lib/components/ui/Button";
import UiCheckbox from "lib/components/ui/Checkbox";
import UiDialog from "lib/components/ui/Dialog";
import UiDialogFooter from "lib/components/ui/DialogFooter";
import UiInput from "lib/components/ui/Input";
import UiRadio from "lib/components/ui/Radio";
import UiRadioGroup from "lib/components/ui/RadioGroup";

export default {
	name: "StreamCreateDialog",
	components: {
		UiButton,
		UiCheckbox,
		UiDialog,
		UiDialogFooter,
		UiInput,
		UiRadio,
		UiRadioGroup
	},
	data() {
		return {
			isDefaultStream: true,
			isExternal: false,
			isFetching: false,
			streamTitle: "",
			streamURI: ""
		};
	},
	mounted() {
		this.open = (recorderId) => {
			this.isDefaultStream = true;
			this.isExternal = false;
			this.recorderId = recorderId;
			this.streamTitle = "";
			this.streamURI = "";

			this.$refs.dialog.open();
		};

		$bus.$on("_stream/CreateDialog.open", this.open);
	},
	beforeDestroy() {
		$bus.$off("_stream/CreateDialog.open", this.open);
	},
	methods: {
		createStream() {
			const parameters = {
				title: this.streamTitle
			};

			if (this.isExternal)
				parameters.uri = this.streamURI;

			if (this.isDefaultStream)
				parameters.default = true;

			this.isFetching = true;

			http.post(`/api/v2/recorder/${this.recorderId}/stream`, parameters)
			.then((response) => {
				this.$refs.dialog.close();
				this.$emit("create", { ...response.data, default: this.isDefaultStream });
			})
			.catch((error) => {
				alert.error("Unable to create stream", error.response);
			})
			.finally(() => {
				this.isFetching = false;
			});
		}
	}
};
</script>
